import posthog from 'posthog-js'
(function ($, Drupal) {
    'use strict';
    Drupal.behaviors.events = {
      attach: function (context, settings) {
        $(document).ready(function(){
            posthog.init('phc_4ODc0LXGRrfbevwLjwqpU2Gr0XaKJgQB0vRe8tKJRFK', { api_host: 'https://app.posthog.com', autocapture: false, capture_pageview: false, capture_pageleave: false })
            $('#distributorsList').on('click', '.distributorsbuynow', function(event){
                event.preventDefault();
                var title = $(this).attr('title');
                var d_url = $(this).attr('href');
                var evenTitle = title.split('-').join('_');
                evenTitle = evenTitle.split(' ').join('_');
                evenTitle = evenTitle.toLowerCase(); 
                var sku = $('#product__sku').text();
                posthog.capture('Buy Now button Click', {
                  sku: sku,
                  distributor: title,
                  url: d_url
                });
            });
        });
    }
  };
})(jQuery, Drupal);